import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { Link } from 'components/commercetools-ui/organisms/header/types';
import Slideout, { MenuState } from 'components/commercetools-ui/organisms/header/utility-section/components/slide-out';
import CartIcon from 'components/icons/cart';
import WishlistIcon from 'components/icons/wishlist';
import { useFormat } from 'helpers/hooks/useFormat';
import { useAccount, useCart, useWishlist } from 'frontastic';
import { ImageProps } from 'frontastic/lib/image';
import AccountButton from './components/account-button';
import CartDrawer from './components/drawer';
import SlideoutCart from './components/side-out-new';

export interface Props {
  emptyCartTitle: string;
  emptyCartSubtitle: string;
  emptyCartImage: ImageProps;
  emptyCartCategories: Link[];
  emptyWishlistTitle: string;
  emptyWishlistSubtitle: string;
  emptyWishlistImage: ImageProps;
  emptyWishlistCategories: Link[];
}

const UtilitySection: React.FC<Props> = ({
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartImage,
  emptyCartCategories,
  emptyWishlistTitle,
  emptyWishlistSubtitle,
  emptyWishlistImage,
  emptyWishlistCategories,
}) => {
  const { totalItems: totalCartItems } = useCart();
  const { totalItems: totalWishlistItems } = useWishlist();
  const { account } = useAccount();
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });
  const { formatMessage: formatWishlistMessage } = useFormat({ name: 'wishlist' });
  const router = useRouter();

  const [menuState, setMenuState] = useState<any>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const onWishlistClicked = () => {
    // setIsDrawerOpen(true);
    // setMenuState('wishlist');
    if (account)
      // router.push('/wishlist');
      window.location.href = '/wishlist';
    else {
      // router.push('/login');
      window.location.href = '/login';
    }
  };

  const onCartClicked = () => {
    // setIsDrawerOpen(true);
    // setMenuState('cart');
    router.push('/cart/');
    // window.location.href = '/cart/';
  };

  const onCartHover = () => {
    setIsDrawerOpen(true);
    setMenuState('cart');
  };

  // const onCartLeave = () => setIsDrawerOpen(false);
  const contentFulHeader = true;
  return !contentFulHeader ? (
    <div className="flex items-center">
      <div className="flex justify-between gap-x-8 lg:gap-x-16">
        <AccountButton />
        <div className="hidden h-30 w-fit lg:block">
          <div
            title={formatWishlistMessage({ id: 'wishlist', defaultMessage: 'Wishlist' })}
            className="relative h-fit cursor-pointer"
            onClick={onWishlistClicked}
          >
            <WishlistIcon
              totalWishlistItems={totalWishlistItems}
              className="wishlist-icon text-26 text-primary-black"
            />
          </div>
        </div>
        <div className="h-30 w-fit ">
          <div
            title={formatCartMessage({ id: 'myCart', defaultMessage: 'My Cart' })}
            className="h-fit cursor-pointer"
            onClick={onCartClicked}
          >
            <CartIcon
              className="cart-icon text-22 text-primary-black"
              totalCartItems={totalCartItems}
              counterClassName="-translate-y-1/4"
            />
          </div>
        </div>
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        direction="right"
        className="w-[90%] max-w-[380px] bg-white"
        onClose={() => setIsDrawerOpen(false)}
      >
        <Slideout
          state={menuState}
          onClose={() => setIsDrawerOpen(false)}
          changeState={(newState) => setMenuState(newState)}
          emptyCartTitle={emptyCartTitle}
          emptyCartSubtitle={emptyCartSubtitle}
          emptyCartImage={emptyCartImage}
          emptyCartCategories={emptyCartCategories}
          emptyWishlistTitle={emptyWishlistTitle}
          emptyWishlistSubtitle={emptyWishlistSubtitle}
          emptyWishlistImage={emptyWishlistImage}
          emptyWishlistCategories={emptyWishlistCategories}
        />
      </Drawer>
    </div>
  ) : (
    <div className="flex items-center">
      <div className="flex justify-between gap-x-8 lg:gap-x-16">
        <AccountButton />
        <div className="relative hidden h-40 w-fit lg:flex">
          <div className="absolute right-[-8px] top-[-6px] block h-[16px] min-w-[16px] rounded-full bg-[#dc143c] text-center text-[9px] font-light leading-[15px] text-white">
            {totalWishlistItems}
          </div>
          <div
            title={formatWishlistMessage({ id: 'wishlist', defaultMessage: 'Wishlist' })}
            className="h-fit cursor-pointer pb-8 after:absolute after:bottom-0 after:left-1/2 after:block after:h-[2px] after:w-0 after:bg-[#7ce3be] after:opacity-0 after:[transition:width_0.45s,margin_0.45s,opacity_0.25s] hover:after:ml-[-50%] hover:after:w-full hover:after:opacity-100"
            onClick={onWishlistClicked}
          >
            <WishlistIcon totalWishlistItems={totalWishlistItems} className="text-28 text-secondary-black" />
          </div>
        </div>
        <div className="ml-3 h-40 w-fit">
          <div
            title={formatCartMessage({ id: 'myCart', defaultMessage: 'My Cart' })}
            className="relative h-fit cursor-pointer pb-8 after:absolute after:bottom-0 after:left-1/2 after:block after:h-[2px] after:w-0 after:bg-[#7ce3be] after:opacity-0 after:[transition:width_0.45s,margin_0.45s,opacity_0.25s] hover:after:ml-[-50%] hover:after:w-full hover:after:opacity-100"
            onClick={onCartClicked}
            onMouseEnter={onCartHover}
          >
            <CartIcon
              className="text-24 text-secondary-black"
              totalCartItems={totalCartItems}
              counterClassName="-translate-y-1/4"
            />
          </div>
        </div>
      </div>
      <CartDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <SlideoutCart
          state={menuState}
          onClose={() => setIsDrawerOpen(false)}
          changeState={(newState) => setMenuState(newState)}
          emptyCartTitle={emptyCartTitle}
          emptyCartSubtitle={emptyCartSubtitle}
          emptyCartImage={emptyCartImage}
          emptyCartCategories={emptyCartCategories}
          emptyWishlistTitle={emptyWishlistTitle}
          emptyWishlistSubtitle={emptyWishlistSubtitle}
          emptyWishlistImage={emptyWishlistImage}
          emptyWishlistCategories={emptyWishlistCategories}
        />
      </CartDrawer>

      {/* <Drawer
        isOpen={isDrawerOpen}
        direction="right"
        className="w-[90%] max-w-[380px] bg-white"
        onClose={() => setIsDrawerOpen(false)}
      >
        <Slideout
          state={menuState}
          onClose={() => setIsDrawerOpen(false)}
          changeState={(newState) => setMenuState(newState)}
          emptyCartTitle={emptyCartTitle}
          emptyCartSubtitle={emptyCartSubtitle}
          emptyCartImage={emptyCartImage}
          emptyCartCategories={emptyCartCategories}
          emptyWishlistTitle={emptyWishlistTitle}
          emptyWishlistSubtitle={emptyWishlistSubtitle}
          emptyWishlistImage={emptyWishlistImage}
          emptyWishlistCategories={emptyWishlistCategories}
        />
      </Drawer> */}
    </div>
  );
};

export default UtilitySection;
